"use client";
import {
  Button_default
} from "./chunk-CGHW2YLJ.mjs";
import {
  Accordion_default
} from "./chunk-VM5JCF36.mjs";

// src/components/sections/Faq/Faq.tsx
import { Text } from "@stone-payments/odin-ui";
import { jsx, jsxs } from "react/jsx-runtime";
var Faq = ({
  title,
  text,
  referId,
  label,
  questions,
  label2
}) => {
  return /* @__PURE__ */ jsx("section", { id: referId, "data-testid": "faq-section", className: "bg-display-100", children: /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-24 lg:gap-40 justify-center items-center py-40 lg:py-[120px] px-24 mx-auto md:max-w-[1280px]", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col lg:flex-row gap-24 lg:gap-40 h-max", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex relative lg:sticky lg:top-40 flex-col gap-16 lg:gap-12 justify-center items-start max-w-full lg:max-w-[435px] xl:max-w-[455px] h-min", children: [
      /* @__PURE__ */ jsx(Text, { type: "DISPLAY-MEDIUM", size: "large", variant: "primary", children: title }),
      /* @__PURE__ */ jsx(Text, { type: "SMALL", size: "large", variant: "primary", children: text }),
      /* @__PURE__ */ jsx(Button_default, { children: label })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex relative flex-col gap-24 items-start", children: [
      /* @__PURE__ */ jsx("ul", { className: "flex flex-col gap-8", children: questions.map(({ question, answer }, index) => {
        return /* @__PURE__ */ jsx(
          Accordion_default,
          {
            question,
            answer,
            currentItemPosition: index + 1,
            itemsLength: questions.length,
            show: true
          },
          index
        );
      }) }),
      /* @__PURE__ */ jsx(Button_default, { color: "secondary", children: label2 })
    ] })
  ] }) }) });
};

export {
  Faq
};
